export default "__VITE_ASSET__059c86ea__"